import { render, staticRenderFns } from "./CreateTransferModal.vue?vue&type=template&id=3fe81841&scoped=true"
import script from "./CreateTransferModal.vue?vue&type=script&lang=js"
export * from "./CreateTransferModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTransferModal.vue?vue&type=style&index=0&id=3fe81841&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe81841",
  null
  
)

export default component.exports